export default {
  login: {
    phone: 'เบอร์โทรศัพท์',
    phoneNumber: 'เบอร์โทรศัพท์',
    password: 'รหัสผ่าน',
    accountNumber: 'เลขที่บัญชี',
    newPassword: 'รหัสผ่านใหม่',
    confirmPassword: 'ยืนยันรหัสผ่านใหม่',
    forgotPassword: 'ลืมรหัสผ่าน',
    contactAdmin: 'ติดต่อแอดมิน',
    loginButton: 'เข้าสู่ระบบ',
    register: 'สมัครสมาชิก',
    confirm: 'ยืนยัน',
    changePassword: 'เปลี่ยนรหัสผ่าน',
    noAccount: 'หรือยังไม่มีบัญชี'
  },
  register: {
    title: 'สมัครสมาชิก',
    verifyOTP: 'ยืนยันรหัส OTP',
    registerSuccess: 'Register Success',
    registrationComplete: 'การสมัครของคุณสำเร็จแล้ว',
    enterPhonePrompt: 'กรุณากรอกเบอร์โทรศัพท์ของท่าน',
    next: 'ต่อไป',
    back: 'ย้อนกลับ',
    otpSent: 'รหัส OTP จะส่งไปที่เบอร์มือถือของท่าน',
    otpSentTo: 'รหัส OTP จะส่งไปที่เบอร์มือถือของท่าน',
    phone: 'เบอร์',
    phoneNumber: 'เบอร์',
    enterOtp: 'กรอกรหัส OTP จากเบอร์มือถือของท่าน',
    enterOTP: 'กรอกรหัส OTP จากเบอร์มือถือของท่าน',
    confirmOtp: 'ยืนยัน OTP',
    confirmOTP: 'ยืนยัน OTP',
    resendOtp: 'รับรหัส OTP ใหม่อีกครั้ง',
    resendOTP: 'รับรหัส OTP ใหม่อีกครั้ง',
    enterPasswordPrompt: 'กรุณากรอกรหัสผ่านของท่าน',
    password: 'รหัสผ่าน',
    setPassword: 'ตั้งรหัสผ่าน 6 ตัวอักษรขึ้นไป',
    confirmPassword: 'พิมพ์รหัสผ่านอีกครั้ง',
    selectBankPrompt: 'กรุณาเลือกธนาคารของท่าน',
    selectBank: 'เลือกธนาคาร',
    accountNumber: 'กรอกเลขบัญชี',
    firstName: 'กรอก ชื่อ',
    lastName: 'กรอก นามสกุล',
    bankHint: 'กรอกข้อมูลให้ครบถ้วนและถูกต้องมิฉะนั้นท่านจะไม่สามารถถอนเงินได้',
    registerButton: 'สมัครสมาชิก',
    success: 'สมัครสมาชิกสำเร็จแล้ว',
    thankYouMessage: 'ขอบคุณสำหรับการสมัคร คุณสามารถใช้ชื่อเข้าระบบ และ รหัสผ่าน ด้านล่างที่ตั้งไว้เพื่อเข้าสู่ระบบ',
    username: 'ชื่อเข้าระบบ',
    loginButton: 'เข้าสู่ระบบ',
    or: 'หรือ',
    alreadyHaveAccount: 'มีบัญชีอยู่แล้ว'
  },
  registerErrors: {
    errorTitle: 'Error!',
    otpTitle: 'OTP!',
    enterOTP: 'โปรดระบุ OTP ที่ได้รับ!!!',
    invalidOTP: 'OTP ไม่ถูกต้องโปรดตรวจสอบ OTP ใหม่!!!',
    otpNotFound: 'OTP ไม่มีในระบบโปรดติดต่อแอดมิน',
    selectBank: 'กรุณาเลือกธนาคารค่ะ!!!',
    enterAccountNumber: 'กรุณากรอกหมายเลขบัญชีค่ะ!!!',
    enterFirstName: 'กรุณากรอกชื่อค่ะ!!!',
    enterLastName: 'กรุณากรอกนามสกุลค่ะ!!!',
    enterPhone: 'กรุณากรอกเบอร์โทรศัพท์ค่ะ!!!',
    phoneLength: 'เบอร์โทร จำนวนตัวอักษรต้อง 10 ตัวเท่านั้นค่ะ!!!',
    phoneExists: 'หมายเลขโทรศัพท์นี้เป็นสมาชิกอยู่แล้วค่ะ หากมีปัญหาโปรดติดต่อ',
    accountExists: 'หมายเลขบัญชีนี้เป็นสมาชิกอยู่แล้วค่ะ หากมีปัญหาโปรดติดต่อ',
    passwordMinLength: 'กรุณากรอกรหัสผ่านอย่างน้อย 6 ตัวอักษรค่ะ!!!',
    passwordMismatch: 'รหัสผ่านไม่ตรงกันค่ะ!!!',
    invalidCredentials: 'เบอร์โทรศัพท์ / รหัสผ่าน ไม่ถูกต้องค่ะ!!!'
  },
  messages: {
    title: 'ข้อความ!',
    enterPhone: 'โปรดระบุเบอร์มือถือค่ะ!!!',
    enterPassword: 'โปรดระบุ Password ค่ะ!!!',
    invalidCredentials: 'เบอร์โทรศัพท์ / รหัสผ่าน ไม่ถูกต้องค่ะ!!!',
    contactAdminError: 'โปรดติดต่อแอดมิน',
    checkPasswordData: 'โปรดตรวจสอบข้อมูลรหัสให้ถูกต้องค่ะ!!!',
    passwordChangedSuccess: 'เปลี่ยนรหัสผ่านเรียบร้อยแล้วค่ะ',
    completeAllInfo: 'โปรดระบุข้อมูลให้ครบด้วยค่ะ!!!',
    enterPhoneAndAccount: 'กรุณากรอกเบอร์โทรศัพท์และเลขที่บัญชี',
    enterNewPassword: 'กรุณากรอกรหัสผ่านใหม่'
  },
  languages: {
    th: 'ไทย',
    en: 'English',
    my: 'Myanmar',
    ch: 'Chinese'
  },
  main: {
    heroTitle: 'จัดหนักจัดเต็มกับการจัดกิจกรรม<br>และสิทธิพิเศษสุดคุ้ม',
    heroSubtitle: 'กิจกรรมมากที่สุดในไทย มีให้นักเดิมพันได้ร่วมสนุกทุกวัน',
    heroCta: 'สมัครสมาชิก',
    searchPlaceholder: 'ค้นหาเกมส์หรือค่ายเกมส์...',
    playButton: 'เข้าเล่น',
    titles: {
      favorite: 'เกมส์โปรด',
      hot: 'เกมส์ยอดนิยม',
      new: 'เกมส์ใหม่',
      casinoAll: 'คาสิโนทั้งหมด',
      casinoProvider: 'ค่าย {name}',
      sport: 'สปอร์ต',
      fishAll: 'เกมส์ยิงปลาทั้งหมด',
      fishProvider: 'เกมส์ยิงปลาค่าย {name}',
      slotAll: 'เกมส์สล๊อตทั้งหมด',
      slotProviders: 'เกมส์สล๊อตค่าย',
      slotProvider: 'เกมส์สล๊อตค่าย {name}',
      card: 'เกมส์ไพ่'
    }
  },
  header: {
    register: 'สมัครสมาชิก',
    registerNow: 'สมัครเลย',
    login: 'เข้าสู่ระบบ',
    deposit: 'ฝากเงิน',
    withdraw: 'ถอนเงิน',
    account: 'บัญชี',
    nav: {
      slot: 'Slot',
      casino: 'คาสิโน',
      sport: 'สปอร์ต',
      event: 'สิทธิพิเศษ',
      privilege: 'สิทธิพิเศษ',
      promotion: 'โปรโมชั่น',
      cashback: 'คืนยอดเล่น',
      continue: 'ฝากต่อเนื่อง',
      continuousDeposit: 'ฝากต่อเนื่อง',
      partner: 'พันธมิตร',
      rewards: 'แลกของรางวัล',
      redeemRewards: 'แลกของรางวัล'
    },
    auth: {
      register: 'สมัครสมาชิก',
      login: 'เข้าสู่ระบบ',
      logout: 'ออกจากระบบ',
      logoutConfirm: 'ต้องการออกจากระบบ ?'
    },
    loginModal: {
      title: 'เข้าสู่ระบบ',
      phonePlaceholder: 'เบอร์โทรศัพท์',
      passwordPlaceholder: 'รหัสผ่าน',
      forgotPassword: 'ลืมรหัสผ่าน',
      submit: 'เข้าสู่ระบบ',
      problem: 'พบปัญหา',
      contactSupport: 'ติดต่อฝ่ายบริการลูกค้า'
    },
    registerModal: {
      title: 'สมัครสมาชิก',
      phonePlaceholder: 'เบอร์โทรศัพท์',
      confirm: 'ยืนยัน',
      back: 'ย้อนกลับ'
    },
    otp: {
      message: 'รหัส OTP จะส่งไปที่เบอร์มือถือของท่าน',
      phoneNumber: 'เบอร์',
      placeholder: 'กรอกรหัส OTP จากเบอร์มือถือของท่าน',
      confirm: 'ยืนยัน OTP',
      resend: 'รับรหัส OTP ใหม่อีกครั้ง'
    },
    password: {
      newPlaceholder: 'ตั้งรหัสผ่าน 6 ตัวอักษรขึ้นไป',
      confirmPlaceholder: 'พิมพ์รหัสผ่านอีกครั้ง',
      currentPlaceholder: 'รหัสผ่านปัจจุบัน',
      new: 'รหัสผ่านใหม่',
      confirmNew: 'พิมพ์รหัสผ่านใหม่อีกครั้ง'
    },
    bank: {
      accountNumberPlaceholder: 'กรอกเลขบัญชี',
      firstnamePlaceholder: 'กรอก ชื่อ',
      lastnamePlaceholder: 'กรอก นามสกุล',
      warning: 'กรอกข้อมูลให้ครบถ้วนและถูกต้องมิฉะนั้นท่านจะไม่สามารถถอนเงินได้'
    },
    registerSuccess: {
      title: 'สมัครสมาชิกสำเร็จแล้ว',
      usernameLabel: 'Username: ',
      passwordLabel: 'Password: '
    },
    depositModal: {
      title: 'แจ้งฝากพร้อมเพย์',
      modalTitle: 'ฝากเงิน',
      click: 'Click',
      copy: 'คัดลอก',
      scbBank: 'ธนาคารไทยพาณิชย์',
      ttbBank: 'ธนาคารทหารไทยธนชาต',
      gsbBank: 'ธนาคารออมสิน',
      kbank: 'ธนาคารกสิกร',
      truemoney: 'ทรูมันนี่ วอลเล็ท',
      promptPay: 'แจ้งฝากพร้อมเพย์',
      warning: 'กรุณาใช้เลขบัญชีที่สมัครโอนเข้ามาเท่านั้น',
      promotionNotice: 'หากต้องการรับโปร โปรดกดรับโปรทุกครั้งก่อนโอนเงินนะคะ',
      generatingInfo: 'กำลังสร้าง QR Code กรุณารอสักครู่... ห้ามปิดหน้าต่างนี้',
      generatingWarning: 'QR CODE นี้ใช้ได้ครั้งเดียวเท่านั้น! ห้ามสแกนซ้ำเด็ดขาด!',
      qrWarning: 'คำเตือน: QR CODE นี้ชำระได้เพียงครั้งเดียวเท่านั้น ห้ามทำรายการซ้ำ หากทำซ้ำอาจจะทำให้ยอดเงินของท่านเข้าล่าช้าได้',
      receive: 'รับ',
      notReceive: 'ไม่รับ',
      noBonusNotice: 'ฝาก ไม่รับโบนัส ถอนได้ทันทีไม่มีเงื่อนไข',
      amountPlaceholder: 'จำนวนเงินที่ต้องการฝาก',
      slipReminder: 'หากเงินไม่เข้าภายใน 5 นาที อัพโหลดสลิปที่นี่!!',
      closeButton: 'ปิดหน้าต่าง',
      confirm: 'ยืนยันการฝาก',
      confirmDeposit: 'แจ้งฝาก',
      loading: 'กำลังโหลด...',
      generatingButton: 'กำลังสร้าง QR Code...',
      minAmountError: 'จำนวนเงินต้องมากกว่า {amount} บาท',
      depositError: 'แจ้งฝากพร้อมเพย์มีปัญหา',
      contactAdmin: 'โปรดติดต่อ admin',
      depositSuccess: 'แจ้งฝากพร้อมเพย์เรียบร้อย'
    },
    withdrawModal: {
      modalTitle: 'ถอนเงิน',
      amountPlaceholder: 'จำนวนเงินที่ต้องการถอน',
      minimumNotice: '- ถอนขั้นต่ำ 100 บาท',
      confirmButton: 'ยืนยัน',
      withdrawNotice: 'แจ้งถอน',
      turnoverComplete: 'คุณทำเทิร์นครบแล้ว! จะถอนได้ {amount} บาท กดปุ่มยืนยันการถอนได้เลยค่ะ',
      turnoverCompleteSimple: 'คุณทำเทิร์นครบแล้ว! กดปุ่มยืนยันการถอนได้เลยค่ะ'
    },
    promotion: {
      title: 'โปรโมชั่น',
      receive: 'รับโปรโมชั่น'
    },
    support: {
      customerService: 'ฝ่ายบริการลูกค้า',
      service24h: 'ดูแลคุณ 24 ชั่วโมง'
    }
  },
  promotionPage: {
    heroTitle: 'โปรแรงเวอร์ กิจกรรมเพียบ<br>จัดหนัก แรงที่สุดในตอนนี้',
    heroSubtitle: 'เกมส์เยอะ โปรโมชั่นดี อันดับ 1 ของจริง ไม่ใช่ทุกคนที่ทำได้',
    heroCta: 'สมัครสมาชิก'
  },
  eventPage: {
    heroTitle: 'กิจกรรมเพียบ<br>จัดหนัก แรงที่สุดในตอนนี้',
    heroSubtitle: 'เกมส์เยอะ โปรโมชั่นดี อันดับ 1 ของจริง ไม่ใช่ทุกคนที่ทำได้',
    heroCta: 'สมัครสมาชิก',
    alerts: {
      error: 'Error!',
      success: 'Success',
      creditExceeds: 'พี่จ๋ามีมีมากกว่า 4 เครดิต ไม่สามารถเล่นได้นะคะ!!!',
      creditExceeds10: 'พี่จ๋ามีมากกว่า 10 เครดิต ไม่สามารถเล่นได้นะคะ!!!',
      checkinAlready: 'ท่าน Check-in วันนี้แล้วนะคะรอพรุ่งนี้นะคะ!!!',
      checkinSuccess: 'ท่าน Check-in เรียบร้อยแล้วค่ะ',
      checkinVerify: 'โปรดตรวจสอบสิทธิ์การ Check-in!',
      enterCode: 'โปรดกรอกรหัส',
      confirm: 'ตกลง',
      cancel: 'ยกเลิก',
      codeInvalid: 'โปรดตรวจสอบ Code ค่ะ!!',
      codeAlreadyUsed: 'ท่านรับ Code ฟรีไปแล้ว!!'
    }
  },
  cashbackPage: {
    title: 'คืนยอดเล่น',
    playSummary: 'ยอดเล่น',
    deposit: 'ฝาก',
    withdraw: 'ถอน',
    totalIncome: 'รายได้ทั้งหมด',
    transferButton: 'โอนเงินเข้ากระเป๋าหลัก'
  },
  partnerPage: {
    title: 'ลิงก์รับทรัพย์',
    copy: 'คัดลอก',
    copyTitle: 'คัดลอก',
    copySuccess: 'คัดลอกเรียบร้อยแล้ว',
    shareHint: 'ส่งลิงก์ได้ทุกช่องทาง รับทรัพย์กับเราได้ทันที',
    earningsTitle: 'รายได้ผู้แนะนำ',
    levelOne: 'แนะนำเพื่อน',
    levelTwo: 'เพื่อนแนะนำเพื่อน',
    levelOneIncome: 'รายได้แนะนำเพื่อน',
    levelTwoIncome: 'รายได้เพื่อนแนะนำเพื่อน',
    totalIncome: 'รายได้ทั้งหมด',
    summaryNote: '*ข้อมูลสรุปยอดเมื่อวาน',
    table: {
      code: 'รหัส',
      date: 'วันที่',
      deposit: 'ฝาก',
      withdraw: 'ถอน'
    },
    levelOneModalTitle: 'แนะนำเพื่อน',
    levelTwoModalTitle: 'เพื่อนแนะนำเพื่อน'
  },
  continuePage: {
    title: 'ฝากต่อเนื่อง',
    defaultPromotion: 'ฝากต่อเนื่อง 7 วัน',
    bonus: 'โบนัส',
    rulesHtml: '<p style="text-align:center;padding:30px;font-size:16px;font-family:Kanit;">'
      + '<b>• สมาชิกมียอดฝากติดต่อกัน 7 วัน</b><br>'
      + '✨ ฝากรวม 999 บ./วัน <span style="color:#FAB537">รับโบนัส 100 บ.</span><br>'
      + '✨ ฝากรวม 1,999 บ./วัน <span style="color:#FAB537">รับโบนัส 200 บ.</span><br>'
      + '✨ ฝากรวม 2,999 บ./วัน <span style="color:#FAB537">รับโบนัส 300 บ.</span><br>'
      + '✨ ฝากรวม 3,999 บ./วัน <span style="color:#FAB537">รับโบนัส 400 บ.</span><br>'
      + '✨ ฝากรวม 4,999 บ./วัน <span style="color:#FAB537">รับโบนัส 500 บ.</span><br>'
      + '✨ ฝากรวม 5,999 บ./วัน <span style="color:#FAB537">รับโบนัส 600 บ.</span><br>'
      + '✨ ฝากรวม 6,999 บ./วัน <span style="color:#FAB537">รับโบนัส 700 บ.</span><br>'
      + '✨ ฝากรวม 7,999 บ./วัน <span style="color:#FAB537">รับโบนัส 800 บ.</span><br>'
      + '✨ ฝากรวม 8,999 บ./วัน <span style="color:#FAB537">รับโบนัส 900 บ.</span><br>'
      + '✨ ฝากรวม 9,999 บ./วัน <span style="color:#FAB537">รับโบนัส 1,000 บ.</span><br>'
      + '• ใช้เล่นได้เฉพาะคาสิโนและเกมที่กำหนดเท่านั้น<br>'
      + '• เล่นสล็อตห้ามซื้อฟีเจอร์ (ฟรีสปิน)<br>'
      + '• ถอนได้สูงสุด 3 เท่าของโบนัส<br>'
      + '• โบนัสเป็นเครดิตช่วยเล่น ไม่สามารถถอนเป็นเงินได้ และจะถูกดึงกลับเมื่อแจ้งถอน (ตัวอย่าง โบนัส 100 ถอนได้ 300 หากเครดิตมากกว่า 300 ส่วนต่างจะถูกดึงคืนทันที)<br>'
      + '• รับโบนัสอัตโนมัติได้ทุกวัน เวลา 08.00 - 23.45 น.<br>'
      + '• ก่อนรับโบนัสต้องมีเครดิตคงเหลือต่ำกว่า 10 บาท'
      + '</p>'
  },
  huayPage: {
    title: 'เงื่อนไขฝาก',
    depositCondition: '**เงื่อนไขฝากทุกๆ 300 ได้รับสิทธิ์ทันที เฉพาะวันที่หวยออก**',
    rewardText: 'ทายถูกรับ 500 เครดิต ทำเทิร์น 2 เท่า',
    conditionsTitle: '📣เงื่อนไขเข้าร่วมกิจกรรม   📣',
    condition1: '1. ยอด 300 บาท ขึ้นไป',
    condition2: '2. 1 สลิปสามารถรับสิทธ์ 1ครั้งในการท้ายผล',
    condition3: '3.ทายรางวัลเลข 2 ตัวบนได้ สูงสุด ไม่จำกัดครัง',
    condition4: '4.ปิดการทายพล 15:00 ของวันที่หวยออก',
    condition5: '5.มีรายการเล่น 1 เทิร์น ก่อนเวลา 16:00 ของวันที่หวยออก',
    condition6: '6.รางวัลเครดิตฟรีจะถูกเพิ่มให้ทายภายในเวลา 19:00 ของวันที่หวยออก',
    confirmButton: 'ยืนยันแทงหวย',
    loading: 'loading...',
    loadingText: 'loading',
    successMessage: 'แทงหวยเรียบร้อยแล้วค่ะ 😘',
    checkRightsAlert: 'โปรดตรวจสอบสิทธิ์จำนวนที่แทง',
    errorMessage: 'เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง',
    okButton: 'OK'
  },
  rouletPage: {
    title: 'รูเล็ตรับเครดิตฟรี',
    depositCondition: '**เงื่อนไขฝากทุกๆ 1000 ได้รับสิทธิ์ทันที เฉพาะวันจันทร์และวันศุกร์**',
    spinButton: 'หมุนได้เลย',
    spinRights: 'สิทธิ์หมุน',
    rounds: 'ครั้ง',
    depositPrompt: 'เงื่อนไขฝากทุกๆ 1000 ได้รับสิทธิ์ทันที',
    creditExceeds: 'พี่จ๋ามีมีมากกว่า 4 เครดิต ไม่สามารถเล่นได้นะคะ!!!',
    noPermissionTitle: 'ไม่มีสิทธิ์หมุนรูเล็ต',
    noPermission: 'เงื่อนไขฝากทุกๆ 1000 ได้รับสิทธิ์ทันที เฉพาะวันจันทร์และวันศุกร์',
    loseMessage: 'เสียใจด้วยคะไม่ถูกรางวัลในครั้งนี้',
    winMessage: 'ยินดีด้วยคะได้',
    credit: 'เครดิต',
    coin: 'เหรียญ',
    okButton: 'ตกลง'
  },
  spinPage: {
    title: 'วงล้อรับเครดิตฟรี',
    depositCondition: '**เงื่อนไขฝากทุกๆ 500 ได้รับสิทธิ์ทันที เฉพาะวันจันทร์และวันศุกร์**',
    spinRights: 'สิทธิ์หมุน',
    rounds: 'รอบ',
    depositPrompt: 'เงื่อนไขฝากทุกๆ 500 ได้รับสิทธิ์ทันที',
    creditExceeds: 'พี่จ๋ามีมีมากกว่า 4 เครดิต ไม่สามารถเล่นได้นะคะ!!!',
    noPermissionTitle: 'ไม่มีสิทธิ์หมุนวงล้อ',
    noPermission: 'เงื่อนไขฝากทุกๆ 500 ได้รับสิทธิ์ทันที เฉพาะวันจันทร์และวันศุกร์',
    winMessage: 'คุณได้รับ',
    credit: 'เครดิต',
    points: 'Points',
    formula: 'สูตรการคำนวณ',
    hours: 'ชั่วโมง',
    okButton: 'ตกลง'
  },
  common: {
    conditionTitle: 'เงื่อนไข',
    conditionMessage: 'ต้องมีเครดิตต่ำกว่า 5 บาท ถึงรับได้ค่ะ',
    confirm: 'ยืนยัน',
    back: 'ย้อนกลับ',
    haveProblem: 'พบปัญหา',
    contactSupport: 'ติดต่อฝ่ายบริการลูกค้า'
  },
  account: {
    info: 'ข้อมูลบัญชี',
    joinedPromotion: 'โปรโมชั่นที่เข้าร่วม',
    history: 'ประวัติธุรกรรม',
    logout: 'ออกจากระบบ',
    confirmLogout: 'ต้องการออกจากระบบ ?',
    changePassword: 'เปลี่ยนรหัสผ่าน',
    currentPassword: 'รหัสผ่านปัจจุบัน',
    newPassword: 'รหัสผ่านใหม่',
    confirmNewPassword: 'พิมพ์รหัสผ่านใหม่อีกครั้ง'
  },
  home: {
    category: {
      jackpot: 'Jackpot Games',
      popular: 'Popular Games',
      new: 'New Games',
      slot: 'Slot Games',
      liveCasino: 'Live Casino',
      review: 'รีวิวถอนลูกค้า'
    },
    game: {
      play: 'เข้าเล่น',
      lobby: 'เข้า Lobby',
      allGames: 'All games',
      gamesCount: 'Games'
    },
    badge: {
      hot: 'Hot',
      new: 'New'
    },
    popular: {
      title: 'รวมเกมแตกบ่อย สล็อตออนไลน์ยอดฮิต',
      highPayout: 'อัตราจ่ายสูง',
      easyBonus: 'โบนัสแตกง่าย',
      funGraphics: 'ภาพและเสียงสนุก',
      playAnytime: 'เล่นได้ทุกที่ 24 ชม.'
    },
    slot: {
      title: 'เล่นได้ทุกค่ายเกม ไม่ต้องโยกเงิน',
      allProviders: 'มีให้เล่นทุกค่ายเกม',
      directWeb: 'ให้บริการผ่านเว็บตรง',
      autoSystem: 'ระบบอัตโนมัติ',
      safe: 'ปลอดภัย 100%'
    },
    casino: {
      title: 'คาสิโนสดชั้นนำ ระดับโลก!',
      baccarat: 'บาคาร่า',
      sicbo: 'ซิกโบ',
      dragonTiger: 'เสือมังกร',
      poker: 'โป๊กเกอร์',
      roulette: 'รูเล็ต',
      blackjack: 'แบล็คแจ็ค',
      hilo: 'ไฮโล',
      bannerTitle: 'คาสิโนสดชั้นนำ',
      bannerSubtitle: 'บาคาร่า | ซิกโบ | เสือมังกร | รูเล็ต'
    },
    feature: {
      smartWallet: {
        title: 'Smart Wallet',
        detail: 'เล่นได้ทุกเกมส์<br>ไม่ต้องโยกเงิน'
      },
      rank: {
        title: 'อันดับ 1 ในไทย',
        detail: 'เทคโนโลยี และเกมส์<br>จากทั่วทุกมุมโลก'
      },
      transaction: {
        title: 'ฝาก - ถอน เร็วมาก',
        detail: 'ฝาก-ถอนเร็วมาก<br>ด้วยระบบ Bot AI'
      },
      everywhere: {
        title: 'เล่นได้ทุกที่',
        detail: 'ระบบใช้ง่าย<br>รองรับทุกอุปกรณ์'
      },
      support: {
        title: 'บริการด้วยใจ',
        detail: 'ฝ่ายบริการลูกค้า<br>24 ชม ทุกวัน'
      },
      promotion: {
        title: 'โปรดีๆสำหรับคุณ',
        detail: 'กิจกรรมและโปรโมชั่น<br>หลากหลายแรงที่สุดในไทย'
      }
    },
    announcement: {
      title: '📢 ประกาศสำคัญ',
      noShowAgain: 'ไม่ต้องแสดงข้อความนี้อีก',
      acknowledge: 'รับทราบ'
    }
  },
  rewardsPage: {
    heroTitle: 'ของรางวัลเพียบ <br>  จัดหนัก แลกได้ตลอดเวลา',
    heroSubtitle: 'สะสมเหรียญเพื่อแลกของรางวัลที่มีได้หมด ทุกเวลา',
    redeemButton: 'แลกทันที',
    confirmMessage: 'ต้องการแลกของรางวัล {name}',
    confirmYes: 'ยืนยัน',
    confirmNo: 'ยกเลิก',
    creditRedeemTitle: 'แลกเครดิต',
    creditRedeemError: 'ไม่สามารถแลกเครดิตได้เนื่องจากมียอดคงเหลือมากกว่า 5 บาท'
  },
  historyPage: {
    title: 'ประวัติธุรกรรม',
    dateTime: 'วัน/เวลา',
    type: 'ประเภท',
    amount: 'จำนวน',
    status: 'สถานะ',
    types: {
      wheel: 'วงล้อ',
      treasureBox: 'เปิดหีบสมบัติ',
      roulette: 'รูเล็ต',
      checkin: 'check-in',
      code: 'code',
      scratch: 'ขูดๆถูๆ',
      giftBox: 'เปิดกล่องของขวัญ',
      continuousDeposit: 'ฝากต่อเนื่อง',
      partner: 'พันธมิตร',
      cashback: 'คืนยอดเล่น',
      deposit: 'ฝาก',
      withdraw: 'ถอน'
    },
    statuses: {
      completed: 'ดำเนินการแล้ว',
      cancelled: 'ยกเลิก',
      pending: 'รอดำเนินการ'
    }
  },
  footer: {
    contact: {
      customerService: 'ฝ่ายบริการลูกค้า',
      service24h: 'ดูแลคุณ 24 ชั่วโมง'
    },
    actions: {
      home: 'หน้าแรก',
      deposit: 'ฝากเงิน',
      withdraw: 'ถอนเงิน',
      contactUs: 'ติดต่อเรา'
    },
    description: 'เป็นผู้ให้บริการคาสิโนออนไลน์ที่ใหญ่ที่สุดในปี 2024 มีการพัฒนาและแก้ไขระบบอย่างดีที่สุดด้วยทีมงานผู้เชี่ยวชาญ ที่คอยช่วยเหลือนักพนันตลอดการเดิมพัน 24 ชั่วโมง ทำให้ท่านเพลิดเพลินได้เต็มที่ เมื่อท่านเกิดปัญหาใดๆ อีกทั้งเราคือผู้ให้บริการพนันออนไลน์ ที่มีรูปแบบของเกมให้ท่านได้เลือกรับความบันเทิงอย่างหลากหลาย และนอกจากนี้ท่านก็จะได้พบกับโปรโมชั่นสุดคุ้มแบบจัดเต็ม มอบค่าตอบแทนจากการลงทุน ในแบบที่ท่านไม่เคยได้จากที่ไหนมาก่อน',
    banks: {
      title: 'ธนาคารที่เราให้บริการ'
    },
    partners: {
      title: 'พาร์ทเนอร์ที่ร่วมกับเรา'
    },
    autoSystem: 'พร้อมระบบฝาก-ถอน AUTO อัตโนมัติที่รวดเร็ว และ ทันสมัยที่สุดในปัจจุบัน',
    copyright: 'Copyright ©2024, All Rights Reserved. TOKYO789'
  }
}
